import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_tvbgq6xmuj: FaireCollectionEntity = {
  token: "pbc_tvbgq6xmuj",
  type: "collection",
  name: "Mermaid 🧜‍♀️🧜‍♀️",
  heroImageUrl:
    "https://cdn.faire.com/fastly/80e0889a24f24a188b9bd5212d87fce6f66ca608e3a83455ce3ef0d6732ecfb6.jpeg",
  itemCount: 23,
  description:
    "Dive into our new mermaid collection with fun and festive styles for any mermaid celebration or everyday wear!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:38.506Z",
    importedBy: "entity-db-import-collections",
  },
};
